// DesignAPIs.js
import { getToken } from "../utils/auth";
import { API_BASE_URL } from './URL_Header';

export const fetchDesigns = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Design/GetAllDesigns`
    );
    if (!response.ok) throw new Error("Failed to fetch designs");
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchDesignById = async (id) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Design/GetDesign/${id}`
    );
    if (!response.ok) throw new Error("Failed to fetch design");
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchDesignByCode = async (code) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Design/GetDesignByCode/${code}`
    );
    if (!response.ok) throw new Error("Failed to fetch design by code");
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchDesignNameById = async (id) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Design/GetDesignName/${id}`
    );
    if (!response.ok) throw new Error("Failed to fetch design name");
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const createDesign = async (design) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Design/AddDesign`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          categoryId: design.categoryId,
          name: design.name,
          priceBefore: design.oldPrice,
          priceAfter: design.newPrice,
          inStock: design.inStock,
          hasOffer: design.hasOffer,
          imageBase64_1: design.imageBase64_1,
          imageBase64_2: design.imageBase64_2,
          driveLink: design.driveLink,
          code: design.code || "",
          material: design.material || "",
          description: design.description || "",
        }),
      }
    );
    if (!response.ok) throw new Error("Failed to create design");
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const updateDesign = async (id, design) => {
  try {
    const payload = {
      designId: id,
      categoryId: design.categoryId,
      name: design.name,
      priceBefore: design.oldPrice,
      priceAfter: design.newPrice,
      inStock: design.inStock,
      hasOffer: design.hasOffer,
      driveLink: design.driveLink,
      code: design.code || "",
      material: design.material || "",
      description: design.description || "",
    };
    if (design.imageBase64_1) payload.imageBase64_1 = design.imageBase64_1;
    if (design.imageBase64_2) payload.imageBase64_2 = design.imageBase64_2;

    const response = await fetch(`${API_BASE_URL}/Design/EditDesign/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken() ? `Bearer ${getToken()}` : undefined,
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const errorData = await response.text();
      throw new Error(`Failed to update design: ${errorData}`);
    }
    return response.status === 204 ? {} : await response.json();
  } catch (err) {
    console.error("Error updating design:", err);
    throw new Error(err.message);
  }
};

export const toggleDesignStock = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/Design/ToggleInStock/${id}`, {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    if (!response.ok) throw new Error("Failed to toggle design stock");
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const deleteDesign = async (id) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Design/DeleteDesign/${id}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    if (!response.ok) throw new Error("Failed to delete design");
    return response.status === 204 ? {} : await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};